import $ from 'jquery';
import imagesLoaded from 'imagesloaded';
import debounce from 'debounce';

export default class ModalView {
  constructor({ model, el }) {
    this.$el = $(el);
    this.content = model.content;
    this.body = $(document.body);
    this._bindEvents();
    this.enterContent();
    this.openModal();
  }

  _bindEvents() {
    this.events = [
      $('.modal-close', this.$el).on('click.modal-view', event => this.closeModal(event)),
    ];
  }

  _unbindEvents() {
    this.events.forEach($el => $el.off('.modal-view'));
  }

  enterContent() {
    if (this.content.title) {
      $('.modal-title', this.$el).text(this.content.title);
    }

    if (this.content.message) {
      $('.modal-message', this.$el).html(this.content.message);
    }

    if (this.content.button) {
      $('.modal-message', this.$el).append(`<p><span class='modal-close button'>${this.content.button}</span></p>`);
    }
  }

  centerModal() {
    const modalContentHeight = $('.modal-content', this.$el).outerHeight();
    const modalContentWidth = $('.modal-content', this.$el).outerWidth();

    if (modalContentHeight > $(window).height()) {
      $('.modal-content', this.$el).css({
        marginTop: 0,
        marginLeft: -(modalContentWidth / 2),
      });

      this.body.addClass('modal-overflow');
    } else {
      $('.modal-content', this.$el).css({
        marginTop: -(modalContentHeight / 2),
        marginLeft: -(modalContentWidth / 2),
      });

      this.body.removeClass('modal-overflow');
    }
  }

  openModal() {
    this.$el.addClass('active');

    setTimeout(() => this.$el.addClass('opening'),
      20);

    imagesLoaded(this.$el[0], () => {
      this.centerModal();
      $(window).on('resize', debounce(() => this.centerModal(), 50));
      this.$el.addClass('open');
    });

    this.body.on('keyup.modal', (e) => {
      if (e && (e.type === 'keyup') && (e.keyCode === 27)) {
        this.closeModal();
      }
    });
  }

  closeModal() {
    this.body.off('keyup.modal');
    this.$el.removeClass('open');

    this.events.push(this.$el.one('transitionend.modal-view', () => {
      this.$el.removeClass('opening');
      this.$el.removeClass('active');
      this.body.removeClass('modal-overflow');
      this._unbindEvents();
    }));

  }
}
